import React, { useState } from 'react';
import { Child } from '../types';

interface ChildSwitcherProps {
  children: Child[];
  activeChild: Child | null;
  onSelect: (child: Child) => void;
  onAddChild: () => void;
}

const ChildSwitcher: React.FC<ChildSwitcherProps> = ({ children, activeChild, onSelect, onAddChild }) => {
  const [open, setOpen] = useState(false);

  if (children.length === 0) {
    return (
      <button onClick={onAddChild} className="text-sm text-gold-400 hover:text-gold-300 transition-colors font-medium">
        + Add Child
      </button>
    );
  }

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(o => !o)}
        className="flex items-center gap-2 text-sm text-white bg-white/10 hover:bg-white/20 rounded-xl px-3 py-1.5 transition-colors border border-white/10"
      >
        <span className="text-base">👤</span>
        <span className="font-medium">{activeChild?.name || 'Select child'}</span>
        <span className="text-gray-400 text-xs">▾</span>
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-2 bg-[#1a1825] border border-white/10 rounded-2xl shadow-2xl overflow-hidden z-50 min-w-[180px]">
            {children.map(child => (
              <button
                key={child.id}
                onClick={() => { onSelect(child); setOpen(false); }}
                className={`w-full text-left px-4 py-3 text-sm hover:bg-white/10 transition-colors ${
                  activeChild?.id === child.id ? 'text-gold-400 font-semibold' : 'text-white'
                }`}
              >
                {child.name} · age {child.age}
              </button>
            ))}
            <div className="border-t border-white/10">
              <button
                onClick={() => { onAddChild(); setOpen(false); }}
                className="w-full text-left px-4 py-3 text-sm text-gold-400 hover:bg-white/10 transition-colors font-medium"
              >
                + Add child
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ChildSwitcher;
